<div class="shared-main-container page-bg-short">
  <div
    class="home-authenticated"
    [ngClass]="{
      'expanded-telemetry': expandTelematics,
      'has-location': (hasLocationPermission$ | async) && privacySettingsVm?.allowLocationServices,
      'other-vehicles': otherVehicles.length !== 0 && otherVehiclesTabActive
    }"
  >
    @if (!garageItemsLoaded || isVehicleDetailLoading) {
      <div class="vehicle-content-1 loading-panel">
        <div class="inner"></div>
      </div>
    }

    @if (garageItemsLoaded && !hasVehicle) {
      <div class="vehicle-content-container no-vehicle-container">
        <pii-add-vehicle-cta (addVehicleClicked)="showAddBikeForm()" />
      </div>
    }

    @if (garageItemsLoaded && !selectedVehicle && hasVehicle) {
      <div class="vehicle-content-container">
        <pii-vehicle-multi-grid [items]="allItems" (vehicleClicked)="onVehicleClicked($event)" />
      </div>
    }

    @if (garageItemsLoaded && selectedVehicle) {
      <div class="vehicle-content-container" [ngClass]="{ 'display-none': isVehicleDetailLoading }">
        <pii-vehicle-detail
          [vehicleId]="selectedVehicle.id"
          (isLoading)="setVehicleDetailLoading($event)"
          (backClicked)="onVehicleClicked(undefined)"
          (telemetryClicked)="expandTelematics = true"
          (mapClicked)="redirectToMap($event)"
          (promoClicked)="openSubscriptionManagement($event)"
          (ignitionSecurityClicked)="ignitionSecurityClick()"
          (ignitionSecurityStatusUpdated)="ignitionSecurityStatusUpdate()"
          (bannerClicked)="bannerClick($event)"
          (vehicleWakeClicked)="vehicleWakeClick()"
        />
      </div>
    }

    <div class="home-helpful-links">
      <rdx-home-helpful-links [selectedVehicle]="selectedVehicle" />
    </div>

    <div class="main-content">
      <div class="subscription" [ngClass]="{ hide: !showRcPlus }">
        <pii-ride-command-plus
          [vehicleIds]="rcPlusIds"
          [expirationCtaOnly]="true"
          (hasContent)="showRcPlus = $event"
          (clicked)="openSubscriptionManagement($event)"
          (appLinkClicked)="appLinkClick($event)"
        />
      </div>
      @if (!expandTelematics) {
        <rdx-home-rides-list (importRide)="importRide()" />
        <rdx-home-community />
      }
      @if (expandTelematics) {
        <div class="vehicle-health">
          <pii-vehicle-health-dashboard
            [vehicleId]="selectedGarageItem?.id || ''"
            (closeClick)="onTelematicsEvent(false)"
            (dismissAllDtcs)="onDismissAllDtcs()"
            (viewAllCodes)="viewAllCodes()"
            (viewCodeHistory)="viewCodeHistory()"
            (viewMaintenanceSchedule)="viewMaintenanceSchedule()"
            (widgetClick)="widgetClick()"
          />
        </div>
      }
    </div>
  </div>
  <div class="cta">
    <rdx-cta />
  </div>
</div>

<svg class="clip-path-curve" width="0" height="0">
  <defs>
    <clipPath id="backgroundCurve" clipPathUnits="objectBoundingBox">
      <path d="m0 0v1a0.96832 1.3317 0 0 1 0.5-0.19127 0.96832 1.3317 0 0 1 0.5 0.19127v-1z" />
    </clipPath>
  </defs>
</svg>
